import { LocalStorageKey } from '@/constants/localStorageKeys'

import localStorageService from './localStorage'

const getJWTToken = () => {
  return localStorageService.get(LocalStorageKey.token)
}

export default getJWTToken
